import React from 'react';
import { useTranslation } from '../i18n/useTranslation';
import { useSiteInfo, FALLBACK_HOURS } from '../context/WorkingHoursContext';

// The doctor's working hours, shown both at the top of the site and in the footer.
const WorkingHoursBanner = () => {
  const { language } = useTranslation();
  const { workingHours } = useSiteInfo();
  const isRTL = language === 'ar';

  const text = (key) => workingHours[key]?.[language] || FALLBACK_HOURS[key][language];

  return (
    <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-blue-600" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center gap-2 sm:gap-6 text-center">
          <div className="flex items-center justify-center gap-2 sm:gap-3">
            <span className="p-1.5 sm:p-2 bg-white/20 rounded-lg flex-shrink-0">
              <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </span>
            <h3 className="text-sm sm:text-base lg:text-lg font-bold text-white">
              {text('title')}
            </h3>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-0.5 sm:gap-4 text-xs sm:text-sm lg:text-base text-blue-50">
            <span className="font-semibold text-white">{text('days')}</span>
            <span className="hidden sm:inline text-blue-200" aria-hidden="true">|</span>
            <span>{text('time')}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkingHoursBanner;
